import { nanoid } from 'nanoid';

export default function (element, data) {
    const id = nanoid();
    const accordion = data.accordion || "none";
    const initalState = (data.state || "closed") == "open";
    const toggle = element.querySelector(".collapse-toggle");
    const wrap = element.querySelector(".collapse-wrap");
    const content = element.querySelector(".collapse-content");

    let isOpen = initalState;

    toggle.addEventListener("click", function () {
        if (!isOpen) {
            open();
        } else {
            close();
        }
    });

    wrap.addEventListener("transitionend", function () {
        if (isOpen) {
            wrap.style.height ="auto";
            wrap.style.overflow = "visible";
        }
    });

    window.addEventListener("collapseOpen", function (event) {
        if (event.detail.accordion && event.detail.accordion != "none" && event.detail.accordion == accordion && event.detail.id != id) {
            close();
        }
    });

    if (initalState) {
        open();
    } else {
        close();
    }

    function open() {
        if (!isOpen) {
            isOpen = true;
            const height = content.offsetHeight;

            element.classList.add("collapse-open");
            wrap.style.height = height + "px";
            wrap.style.overflow = "hidden";

            window.dispatchEvent(new CustomEvent("collapseOpen", {
                detail: {
                    id: id,
                    accordion: accordion
                }
            }));
        } else {
            wrap.style.height = "auto";
            wrap.style.overflow = "visible";
        }
    }

    function close() {
        wrap.style.overflow = "hidden";

        if (isOpen) {
            isOpen = false;
            const height = content.offsetHeight;

            element.classList.remove("collapse-open");
            wrap.style.height = height + "px";
            setTimeout(function () {
                wrap.style.height = "0px";
            }, 1);
        } else {
            wrap.style.height = "0px";
        }
    }
}

// @widgetLoadingMode:lazy-once
// @widgetLoadingChunk:secondary